import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import MonitoringListSelect from '../FormComponents/MonitoringListSelect';
import { ChargeAttemptsFilters as FiltersType, ChargeSource } from '../../types/payment.types';

interface ChargeAttemptsFiltersProps {
  onApply: (filters: FiltersType) => void;
  onClear: () => void;
}

function ChargeAttemptsFilters({ onApply, onClear }: ChargeAttemptsFiltersProps) {
  const [monitoringListId, setMonitoringListId] = useState('');
  const [amountMin, setAmountMin] = useState('');
  const [amountMax, setAmountMax] = useState('');
  const [cardType, setCardType] = useState('');
  const [success, setSuccess] = useState('');
  const [source, setSource] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleDataChange = (key: string, value: string) => {
    if (key === 'monitoringListId') {
      setMonitoringListId(value);
    }
  };

  const handleApply = () => {
    const filters: FiltersType = {};

    if (monitoringListId && monitoringListId !== 'NEW') {
      filters.monitoringListId = monitoringListId;
    }
    if (amountMin) {
      filters.amountMin = parseFloat(amountMin);
    }
    if (amountMax) {
      filters.amountMax = parseFloat(amountMax);
    }
    if (cardType) {
      filters.cardType = cardType;
    }
    if (success) {
      filters.success = success === 'true';
    }
    if (source) {
      filters.source = source as ChargeSource;
    }
    if (startDate) {
      filters.startDate = startDate;
    }
    if (endDate) {
      filters.endDate = endDate;
    }

    onApply(filters);
  };

  const handleClear = () => {
    setMonitoringListId('');
    setAmountMin('');
    setAmountMax('');
    setCardType('');
    setSuccess('');
    setSource('');
    setStartDate('');
    setEndDate('');
    onClear();
  };

  return (
    <>
      <Row className="g-2 mb-2 align-items-end">
        <Col xs={6} md={2}>
          <Form.Label className="small mb-1">Start Date</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            size="sm"
          />
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="small mb-1">End Date</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            size="sm"
          />
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="small mb-1">Source</Form.Label>
          <Form.Select value={source} onChange={(e) => setSource(e.target.value)} size="sm">
            <option value="">All Sources</option>
            <option value="ChargeAll">Charge All</option>
            <option value="Manual">Manual</option>
            <option value="Monitoring">Monitoring</option>
            <option value="GenerateInvoices">Gen. Invoices</option>
            <option value="External">External</option>
          </Form.Select>
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="small mb-1">Status</Form.Label>
          <Form.Select value={success} onChange={(e) => setSuccess(e.target.value)} size="sm">
            <option value="">All</option>
            <option value="true">Successful</option>
            <option value="false">Failed</option>
          </Form.Select>
        </Col>

        <Col xs={12} md={3}>
          <Form.Label className="small mb-1">Monitoring List</Form.Label>
          <MonitoringListSelect
            handleDataChange={handleDataChange}
            value={monitoringListId}
            addNew={false}
            showAllOption={true}
          />
        </Col>
      </Row>

      <Row className="g-2 mb-3 align-items-end">
        <Col xs={6} md={2}>
          <Form.Label className="small mb-1">Min Amount</Form.Label>
          <Form.Control
            type="number"
            placeholder="$ Min"
            value={amountMin}
            onChange={(e) => setAmountMin(e.target.value)}
            size="sm"
          />
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="small mb-1">Max Amount</Form.Label>
          <Form.Control
            type="number"
            placeholder="$ Max"
            value={amountMax}
            onChange={(e) => setAmountMax(e.target.value)}
            size="sm"
          />
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="small mb-1">Card Type</Form.Label>
          <Form.Select value={cardType} onChange={(e) => setCardType(e.target.value)} size="sm">
            <option value="">All Cards</option>
            <option value="visa">Visa</option>
            <option value="mastercard">Mastercard</option>
            <option value="amex">Amex</option>
            <option value="discover">Discover</option>
          </Form.Select>
        </Col>

        <Col xs={12} md={2}>
          <div className="d-flex gap-2">
            <Button variant="primary" size="sm" onClick={handleApply}>
              Apply
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={handleClear}>
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default ChargeAttemptsFilters;
